import { authAxiosClient } from '@/lib';
import { withLogger } from '@/utils';
import { creditsAPIUrls } from '../data';

type Param = {
  id: string;
  data: {
    amount: number;
    reason?: string;
    type?: string;
  };
};

type Return = boolean;

export const updateUserCredit = withLogger(
  async (props: Param): Promise<Return> => {
    await authAxiosClient.put(creditsAPIUrls.updateCredit.replace('{id}', props.id), props.data);

    return true;
  },
);
